// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__16WJE","content":"styles_content__37E4R"};